module.exports = __webpack_public_path__ + "img/sec-05-nh.2f0a8593.svg";